import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-vessel-finder-confirm',
  templateUrl: './vessel-finder-confirm.component.html',
  standalone: false,
})
export class VesselFinderConfirmComponent {
  vesselName: string = '';
  imo: string = '';

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {
    this.vesselName = this.config.data?.vesselName || '';
    this.imo = this.config.data?.imo || '';
  }
}
